<template>
    <div>
        <nav class="navbar navbar-expand-xl navbar-dark bg-dark menutab">
            <h2 class="navbar-brand page-title"><!-- {{ tabs.nom }} --></h2>
            <!-- 	<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample06" aria-controls="navbarsExample06" aria-expanded="false" aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button> -->

            <div class="collapse navbar-collapse" id="navbarsExample06">
                <ul class="navbar-nav mr-auto">
                    <li
                        class="nav-item"
                        v-for="i in tabs.options"
                        :key="i.id"
                        v-bind:class="{ 'no-border': i.id === isActive }"
                    >
                        <a
                            :href="i.ruta"
                            class="nav-link"
                            v-bind:class="{ active: i.id === isActive }"
                            @click.prevent="submenuActive(i)"
                        >
                            {{ i.name }}
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
        <menuCuerpo :items="subMenu"></menuCuerpo>
    </div>
</template>

<script>
import menuCuerpo from "@/components/dimenu/menu/menu_cuerpo.vue";
export default {
    name: "menu_tab",
    components: {
        menuCuerpo,
    },
    props: {
        dataView: { type: Object, required: true },
    },
    data () {
        return {
            isActive: 1,
            tabs: {},
            subMenu: {
                title: "",
                id: 1,
                retorno: 1,
            },
        }
    },
    created () {
        this.tabs = this.dataView;
        //console.log('tab =',this.dataView)
        this.submenuActive(this.subMenu);
    },
    methods: {
        submenuActive(i) {
            if (i.id === 1) {
                this.subMenu.title = window.lang2.label_mn_lst;
            }
            if (i.id === 2) {
                this.subMenu.title = window.lang2.label_extras;
            }
            if (i.id === 3) {
                this.subMenu.title = window.lang2.label_variants;
            }
            this.subMenu.id = i.id;
            this.subMenu.retorno = 1;
            this.isActive = i.id;
            // console.log('enviando DisplayContent', this.subMenu)
            //debugger;
            this.$store.commit("SET_MENU_TAB", this.subMenu);
        },
    },
}
</script>
<style lang="scss" scoped>
@media (min-width: 770px) {
    #navbarsExample06 {
        display: flex !important;
    }
}
.menutab {
    background-color: #222223 !important;
    padding: 0rem 1rem;
    padding-left: 0px;
}
h2.navbar-brand.page-title {
    min-width: 0px;
    padding-bottom: 3px;
    padding-right: 0px;
    margin: 0;
}
.navbar-expand-xl .navbar-nav > li:nth-child(1) {
    border-left: 0px solid #ccc;
}

.navbar-expand-xl .navbar-nav > li.nav-item {
    padding: 0px;
    border-right: 0px solid #ccc;
}
.navbar-expand-xl .navbar-nav > li.nav-item > a {
    padding: 0.5rem 1rem;
}
.navbar-expand-xl .navbar-nav > li.nav-item > a.active,
.navbar-expand-xl .navbar-nav > li.nav-item > a:hover {
    background-color: #585858;
    color: #fff !important;
    font-weight: bold;
}
.navbar-expand-xl .navbar-nav > li.no-border {
    border-right: 0px solid #ccc;
}
</style>
